import { data } from "./data.js";
import "./steps.scss";

class Steps {
    constructor() {
        this.state = {
            question: 1,
            answear: 0,
            branch: "init",
            multiple: false,
            trueOrFalse: false,
            grid: false,
            init: true,
            final: false,
            delay: 80,
            currentData: null,
            return: "",
            isTrue: false,
            showAnswear: false,
            isInit: false,
            tmpBarnch: 0,
            multipleChoice: false,
            answears: [],
        };

        this.data = data;

        this.init();
    }

    initHTML = () => {
        this.stepSection = document.querySelector("[data-step-section]");
        this.initSection = document.querySelector("[data-init-section]");
        this.finalSection = document.querySelector("[data-final-section]");
        this.initButton = document.querySelector("[data-init-button]");
        this.section = null;
        this.animateElements = null;
        this.answearButtons = [];
    };

    createButton = (html, classes) => {
        const button = document.createElement("button");
        button.setAttribute("type", "button");
        button.classList.add(...classes);
        button.innerHTML = html;
        return button;
    };

    createQuestion = (html) => {
        const block = document.createElement("h1");
        block.classList.add("h1", "mb-30", "animate");
        block.innerHTML = html;
        block.setAttribute("data-animate", "true");
        return block;
    };

    createAnswear = (html, index, state) => {
        const button = document.createElement("div");
        button.classList.add("card", "mb-20", "card--hover", "card--accent");
        button.innerHTML = html;
        button.setAttribute("data-index", index);
        button.addEventListener("click", this.handleAnswear);
        button.innerHTML = html;
        button.setAttribute("data-animate", "true");
        if (state) {
            button.setAttribute("data-state", "true");
        }
        return button;
    };

    createNextButton = (html) => {
        this.nextButton = this.createButton(html, [
            "button",
            "text-uppercase",
            "animate",
            "next-button",
        ]);

        this.nextButton.addEventListener("click", this.handleNext);
        this.nextButton.setAttribute("disabled", "disabled");
        this.nextButton.setAttribute("data-animate", "true");

        if (this.state.multiple) {
            this.nextButton.textContent = "Выбрать";
        }

        return this.nextButton;
    };

    createReturn = (html) => {
        const block = document.createElement("div");
        block.classList.add("font-small", "return-block");
        block.innerHTML = html;
        block.setAttribute("data-animate", "true");
        block.style.cssText = `
            transform: scale(0);
            padding: 0;
            opacity: 0;
            height: 0;
            filter: blur(10px);
        `;
        return block;
    };

    getReturnHTML = () => {
        const returnHTML =
            this.state.currentData.return ||
            this.state.currentData.answears[this.state.answear]?.return;
        const isReturn = Boolean(returnHTML);
        if (isReturn) return returnHTML;
    };

    showReturnBlock = () => {
        const returnHTML = this.getReturnHTML();
        const isReturn = Boolean(returnHTML);
        if (isReturn) {
            const returnBlock = this.createReturn(returnHTML);
            this.currentButton.append(returnBlock);
            this.state.showAnswear = true;
            // this.currentButton.style.height = `${this.currentButton.scrollHeight}px`
            // this.currentButton.classList.add('button-animation')
            // this.currentButton.style.height = `${returnBlock.scrollHeight + this.currentButton.scrollHeight}px`
            setTimeout(() => {
                returnBlock.style.cssText = `
                    opacity: 1;
                    transform: scale(1);
                    height: auto;
                    filter: blur(0);
                `;
                // this.currentButton.style.height = 'auto'
            }, 0);
        }
    };

    handleAnswear = (event) => {
        this.currentButton = event.currentTarget;
        if (this.currentButton.classList.contains("card--active")) return;
        this.currentButton.classList.add("card--active");

        const index = parseInt(
            this.currentButton.getAttribute("data-index"),
            10
        );
        this.state.answears.push(index);
        this.state.answear = index;
        this.state.isInit = this.state.branch === "init";

        if (this.state.isInit) this.state.branch = index;

        if (!this.state.tmpBarnch) this.state.tmpBarnch = index;

        this.answearButtons.forEach((button) => {
            if (button.classList.contains("card--active")) return;
            button.setAttribute("disabled", "disabled");
            button.removeEventListener("click", this.handleAnswear);
        });

        this.showReturnBlock();

        this.nextButton.removeAttribute("disabled");
    };

    handleNext = () => {
        const label = `rusagro_question${this.state.question}_answer-anything`
        console.log(label);
        if (typeof ym !== "undefined") ym(94708217, "reachGoal", label);
        this.state.showAnswear = false;
        this.setData();
        this.state.question += 1;
        this.setData()
        this.createSection(this.state.currentData);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    setState() {
        if (this.state.final) return;
        if (this.state.init) this.state.init = false;
    }

    setData = () => {
        this.state.currentData = this.data[this.state.question];
        this.setState();
    };

    setSection = () => {
        this.section = this.state.init
            ? this.initSection
            : this.state.final
            ? this.finalSection
            : this.stepSection;
        this.animateElements = this.section.querySelectorAll("[data-animate]");
    };

    hideSection = async () => {
        this.section.classList.remove("ended");
        this.section.classList.add("hide");
        setTimeout(() => {
            if (this.state.branch === "init")
                this.section.style.display = "none";
            if (this.state.final) this.section.style.display = "none";
            this.section.classList.remove("hide", "show");
            this.setState();
            this.showSection();
        }, 800);
    };

    showSection = async () => {
        const stepWrapper = document.querySelector("[data-step]");
        if (this.state.final) this.state.branch = "final";
        stepWrapper.setAttribute(
            "data-step",
            this.state.branch === "final"
                ? "3"
                : this.state.branch === "init"
                ? "1"
                : "2"
        );
        this.setSection();
        this.state.grid
            ? this.section.classList.add("grid")
            : this.section.classList.remove("grid");
        this.section.style.display = "block";
        this.animateElements.forEach((element, i) =>
            element.classList.add(`show-${i + 1}`)
        );

        setTimeout(() => {
            this.section.classList.add("show");
        }, 200);
        setTimeout(() => {
            this.section.classList.add("ended");
        }, 800);

        if (this.state.question === 5) {
            this.state.final = true;
        }
    };

    createFinal = () => {
        const checkArr = [
            this.state.answears[0],
            this.state.answears[this.state.answears.length - 1],
        ];
        let currentItem = null
        let currentKey = 0
        Object.keys(this.data.result).forEach(key => {
            const item = this.data.result[key]
            const isEqual = JSON.stringify(item.index) === JSON.stringify(checkArr)
            if (isEqual) {
                currentKey = key
                currentItem = item
            }
        });
        const headers= document.querySelectorAll('[data-final-title]')
        const texts = document.querySelectorAll('[data-final-text]')
        const src = `/assets/images/card_${currentKey}.webp`
        const image = document.querySelector('[data-final-image]')
        image.src = src
        headers.forEach(item => item.innerHTML = currentItem.title)
        texts.forEach(item => item.innerHTML = currentItem.text)
    };
    
    createCounter = () => {
        const block = document.createElement('div')
        block.classList.add('counter')
        block.textContent = `${this.state.question} из 5`
    }

    createSection(data) {
        if (this.state.final) {
            this.stepSection.innerHTML = "";
            this.createFinal();
            this.hideSection();
            return;
        }
        this.stepSection.innerHTML = "";
        const title = this.createQuestion(data.question);
        const nextButton = this.createNextButton("Дальше");
        this.stepSection.append(title);
        this.answearButtons = [];
        Object.keys(data.answears).forEach((key) => {
            const button = this.createAnswear(
                data.answears[key].answear,
                key,
                data.answears[key]?.state
            );
            this.stepSection.append(button);
            this.answearButtons.push(button);
        });
        nextButton.addEventListener("click", this.nextButton);
        this.stepSection.append(nextButton);

        this.hideSection();
    }

    start = () => {
        this.setData();
        this.createSection(this.state.currentData);
    };

    init = () => {
        this.initHTML();
        this.initButton.addEventListener("click", this.start);
        document.addEventListener("pageLoadEnd", this.showSection);
    };
}

new Steps();
